import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { DailyResponseSchema } from "../response/DailyResponse";

const API_VERSION = 'v3';

interface FilterProps {
    property_id: string;
    base_on: string;
    start_date: string;
    end_date: string;
    room_type_id?: string;
}

interface DailyProps {
    filter?: FilterProps;
    type: string | null;
}

const useDaily = (params: DailyProps) => {
    return useQuery({
        queryKey: [
            'report',
            'daily',
            'agent',
            'day',
            params.type, // Tambahkan type ke dalam queryKey
            JSON.stringify(params.filter) // Pastikan filter bisa digunakan sebagai key
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/agent-report-daily`, {
                    params: {
                        filter: params.filter
                    }
                });

                // Validasi response
                const validationResult = DailyResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Agent report daily data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Agent report daily`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && params.type === "daily",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useDaily;